import Badge from '@material-ui/core/Badge';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import { makeStyles } from '@material-ui/core/styles';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import ChatIcon from '@material-ui/icons/Chat';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ClosedCaptionIcon from '@material-ui/icons/ClosedCaption';
import ExitIcon from '@material-ui/icons/ExitToApp';
import MoreIcon from '@material-ui/icons/MoreVert';
import RaiseHandIcon from '@material-ui/icons/PanTool';
import PeopleIcon from '@material-ui/icons/People';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
import clsx from 'clsx';
import DeviceSwitcher from 'components/devices/DeviceSwitcher';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPopoutAction } from 'store/classroom/classroomActions';
import { sendMessageAction, setRaisedHandAction } from 'store/message/messageActions';
import { toggleCaptionsAction } from 'store/video/videoActions';
import HostEndMeetingDialog from './sidebar-components/AssignHostDialog';
import ClassroomChat from './sidebar-components/chat/Chat';
import ExitMeetingDialog from './sidebar-components/ExitMeetingDialog';
import Roster from './sidebar-components/roster/Roster';
import Transcription from './sidebar-components/transcription/Transcription';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    width: `${theme.spacing(7) + 1})`,
    [theme.breakpoints.up('mobile')]: {
      width: theme.spacing(9) + 1,
    },
  },

  drawer: {
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('mobile')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    // padding: theme.spacing(3),
  },
  raisedHand: {
    color: 'gold',
  },
  showCaptions: {
    color: theme.palette.primary.main,
  },
}));

ClassroomStyleWrapper.propTypes = {
  children: PropTypes.node,
};
export default function ClassroomStyleWrapper({ children }) {
  const classes = useStyles();
  const {
    showCaptions,
    isHost,
    roster,
    raisedHand,
    meetingId,
    attendeeId,
    name,
    popout,
    unreadMessages,
  } = useSelector(({ video, chime, message, classroom }) => ({
    showCaptions: video.showCaptions,
    isHost: chime.isHost,
    roster: chime.roster,
    raisedHand: message.raisedHand,
    meetingId: chime.meetingId,
    attendeeId: chime.attendeeId,
    name: chime.name,
    popout: classroom.popout,
    unreadMessages: message.unreadMessages,
  }));
  const dispatch = useDispatch();
  const [hostModalOpen, setHostModalOpen] = useState(false);
  const [exitModalOpen, setExitModalOpen] = useState(false);

  const raise = () => {
    dispatch(
      sendMessageAction({
        type: raisedHand ? 'dismiss-hand' : 'raise-hand',
        payload: {
          attendeeId,
          meetingId,
          name,
        },
      })
    );
    dispatch(setRaisedHandAction({ raisedHand: !raisedHand }));
  };

  const handleOpen = (objData) => {
    const popoutName = objData[1];
    const showPopout = !['Exit', 'Raise Hand', 'Assign Host', 'Show Captions'].includes(popoutName);
    let popoutState =
      popoutName !== popout.name && showPopout
        ? {
            open: true,
            name: popoutName,
          }
        : { open: false, name: '' };
    switch (popoutName) {
      case 'Exit':
        setExitModalOpen(true);
        break;
      case 'Group Chat':
        // setUnreadMessageCount(0)
        break;
      case 'Raise Hand':
        raise();
        popoutState = { ...popout };
        break;
      case 'Assign Host':
        setHostModalOpen(true);
        break;
      case 'Show Captions':
        dispatch(toggleCaptionsAction());
        popoutState = { ...popout };
        break;
      default:
        break;
    }

    dispatch(setPopoutAction({ popout: popoutState }));
  };

  const handleClose = () => {
    dispatch(setPopoutAction({ popout: { open: false, name: '' } }));
  };
  const topNavIcons = [
    [PeopleIcon, 'Roster'],
    [ChatIcon, 'Group Chat'],
    [RaiseHandIcon, 'Raise Hand'],
    [RecordVoiceOverIcon, 'Transcripts'],
    // [MailIcon, 'Direct Messgae'],
    // [PencilIcon, 'Notes'],
  ];
  if (isHost) topNavIcons.push([AssignmentIndIcon, 'Assign Host']);

  const bottomNavIcons = [
    [ClosedCaptionIcon, 'Show Captions'],
    [ExitIcon, 'Exit'],
    [MoreIcon, 'More'],
  ];

  const IconList = ({ icnList }) => (
    <List style={{ padding: 0 }}>
      {icnList.map((obj) => {
        const IconComp = obj[0];
        const popoutName = obj[1];
        return (
          <ListItem button key={popoutName} onClick={() => handleOpen(obj)}>
            <ListItemIcon>
              <Badge
                badgeContent={unreadMessages}
                color="secondary"
                invisible={popoutName !== 'Group Chat' || !unreadMessages > 0}
                className={clsx({
                  [classes.raisedHand]: popoutName === 'Raise Hand' && raisedHand,
                  [classes.showCaptions]: popoutName === 'Show Captions' && showCaptions,
                })}
              >
                <IconComp />
              </Badge>
            </ListItemIcon>
          </ListItem>
        );
      })}
    </List>
  );
  IconList.propTypes = {
    icnList: PropTypes.array,
  };

  return (
    <>
      <Box display="flex" flexGrow={1} overflow="hidden">
        <Box flexGrow={1}>
          <Grid container style={{ padding: 0, height: '100vh' }}>
            <Grid item xs={popout.open ? 9 : 12} style={{ height: '90vh' }}>
              {children}
            </Grid>
            {popout.open && (
              <Grid
                item
                xs={3}
                style={{
                  padding: 0,
                  margin: 0,
                  border: '1px solid lightgrey',
                  display: 'flex',
                  flexDirection: 'column',
                  flexGrow: 1,
                }}
              >
                {popout.name === 'Roster' && <Roster roster={roster} />}
                {popout.name === 'Group Chat' && <ClassroomChat />}
                {popout.name === 'Direct Message' && <ClassroomChat />}
                {popout.name === 'Notes' && <ClassroomChat />}
                {popout.name === 'More' && <DeviceSwitcher />}
                {popout.name === 'Transcripts' && <Transcription />}

                <Box
                  style={{
                    zIndex: 1,
                    position: 'absolute',
                    top: '50%',
                    alignSelf: 'flex-start',
                  }}
                >
                  <IconButton
                    variant="outlined"
                    style={{ borderWidth: 1, borderColor: 'lightgrey', padding: 0 }}
                    onClick={handleClose}
                  >
                    <ChevronRightIcon />
                  </IconButton>
                </Box>
              </Grid>
            )}
          </Grid>
        </Box>
        <Box
          style={{ maxWidth: 60, minHeight: '100vh', border: '1px solid lightgrey' }}
          display="flex"
          flexDirection="column"
          flexGrow={1}
          justifyContent="space-between"
        >
          <Box>
            <IconList icnList={topNavIcons} />
          </Box>

          <Box>
            <IconList icnList={bottomNavIcons} />
          </Box>
        </Box>
      </Box>
      <HostEndMeetingDialog isHost={isHost} open={hostModalOpen} setOpen={setHostModalOpen} />
      <ExitMeetingDialog open={exitModalOpen} setOpen={setExitModalOpen} />
    </>
  );
}
